document.addEventListener("DOMContentLoaded", function () {
  Object.assign(window.GzTheme, {
    namespace: "GZ-WARRANTY",

    // Add to Cart
    addToCart: async function (payload) {
      const endpoint = window.GzTheme.CART_ADD_ENDPOINT;
      const sectionIds = window.GzTheme.getSectionIds();
    
      payload = {
        ...payload,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };
    
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
    
        const data = await res.json();
    
        if (!res.ok) {
          throw new Error(data?.description || `Failed to add to cart — status ${res.status}`);
        }
    
        return data;
      } catch (error) {
        throw error;
      }
    },
    
    // Update cart items
    updateCart: async function (endpoint, payload) {
      const sectionIds = window.GzTheme.getSectionIds();
    
      payload = {
        ...payload,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };
    
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
    
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.description || `Failed to update cart — status ${res.status}`);
        }
    
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Fetch cart data
    fetchCart: async function () {
      const endpoint = window.GzTheme.CART_JSON_ENDPOINT;
    
      try {
        const response = await fetch(endpoint);
        const data = await response.json();
    
        if (!response.ok) {
          const error = new Error(`Failed to fetch cart — status ${response.status}`);
          error.responseData = data;
          error.endpoint = endpoint;
          throw error;
        }
    
        window.GzTheme.CART_DATA = data;
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Product in Cart has Warranty
    productHasWarrantyInCart: async function(cartItems, productId, productKey, warrantyId) {
      let product = null;
      let warranty = null;
    
      // Step 1: Find the product first
      for (const item of cartItems) {
        const props = item?.properties || {};
    
        if (
          String(item.key) !== String(productKey) && 
          Number(item.id) === Number(productId) && 
          props["_warranty.variant_id"] === warrantyId
        ) {
          product = item;
          break;
        }
      }
    
      // Step 2: Once product is found, find its associated warranty
      if (product) {
        for (const item of cartItems) {
          const props = item?.properties || {};
    
          if (
            props["_warranty_uuid"] === product.properties?._warranty_uuid &&
            Number(props["_warranty.associated_variant_id"]) === Number(productId) &&
            Number(item.id) === Number(warrantyId)
          ) {
            warranty = item;
            break;
          }
        }
      }
    
      return {
        productInCart: product || null,
        warrantyInCart: warranty || null
      };
    },

    // Product in Cart has Warranty
    productWithoutWarrantyInCart: async function(cartItems, productId, productKey) {
      let product = null;
    
      // Find same product has NO warranty
      for (const item of cartItems) {
        if (
          String(item.key) !== String(productKey) &&
          Number(item.id) === Number(productId)
        ) {
          const props = item?.properties || {};
        
          // Match if warranty properties are missing
          if (
            typeof props["_warranty_uuid"] === "undefined" ||
            typeof props["_warranty.variant_id"] === "undefined"
          ) {
            product = item;
            break;
          }
        }
      }
    
      return product || null;
    },

    // Add Warranty
    addWarranty: async function(productId, productKey, warrantyId) {
      const NS = window.GzTheme?.namespace || "GZ-WARRANTY";
      const uuid = window.GzTheme.generateUUID();
    
      try {
        // 1. Sync latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items || [];
    
        // 2. Find the product from cart
        const product = cartItems.find(item => item.key === productKey);
    
        // 3. Get product and associated warranty from Cart 
        const { productInCart, warrantyInCart } = 
          await window.GzTheme.productHasWarrantyInCart(cartItems, productId, productKey, warrantyId);
    
        // 4. Same Product and Warranty already exists in cart
        if (productInCart && warrantyInCart) {
          // 4.1 Update the Product and Warranty Quantity in cart AND Remove the orphan product
          const quantity = productInCart.quantity + product.quantity;
          const updates = {
            [product.key]: 0,              // remove old product
            [productInCart.key]: quantity, // update main product qty
            [warrantyInCart.key]: quantity // sync warranty qty
          };

          return window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, { updates })
            .then((data) => data)
            .catch((error) => {
              const message = `Failed to update cart quantities: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  info: "Error while syncing product and warranty quantities.",
                  source: "addWarranty() flow",
                  location: window.location.href,
                  payload: updates,
                  cartItems: cartItems,
                },
                "error",
                null,
                NS
              );
            });
    
        // 5. Same warranty is NOT attached to same product in cart
        } else {
          const quantity = product.quantity;
    
          // 5.1 Update product quantity and attach warranty
          const change = {
            id: product.key,
            quantity: quantity,
            properties: {
              ...product.properties,
              "_warranty_uuid": uuid,
              "_warranty.variant_id": warrantyId
            }
          };
    
          // 5.2 Add warranty to cart
          const add = {
            items: [
              {
                id: warrantyId,
                quantity: quantity,
                properties: {
                  "_warranty_uuid": uuid,
                  "_warranty.associated_variant_id": product.id
                }
              }
            ]
          };

          return window.GzTheme.updateCart(window.GzTheme.CART_CHANGE_ENDPOINT, change)
            .then(() => window.GzTheme.addToCart(add))
            .then((data) => data)
            .catch((error) => {
              const message = `Failed adding warranty: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  source: "addWarranty() flow",
                  changePayload: change,
                  addPayload: add,
                  cartItems: cartItems,
                  location: window.location.href
                },
                "error",
                null,
                NS
              );
            });
        }
      } catch (err) {
        const message = `addWarranty error: ${err?.message || "Unexpected error"}`;
        window.GzTheme.sendLogsToDatadog(
          message,
          {
            source: "addWarranty() flow",
            location: window.location.href,
            productId,
            productKey,
            warrantyId,
          },
          "error",
          null,
          NS
        );
      }
    },

    // Remove Warranty
    removeWarranty: async function(productId, productKey, warrantyId) {
      const NS = window.GzTheme?.namespace || "GZ-WARRANTY";
    
      try {
        // 1. Sync latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items || [];
    
        // 2. Find the product from cart
        const product = cartItems.find(item => item.key === productKey);

        // 3. Find the warranty from cart
        const warranty = cartItems.find(item => 
          item?.id === warrantyId && 
          item?.properties["_warranty.associated_variant_id"] === productId
        );
    
        // 4. Find same product without warranty
        const productWithoutWarranty = await window.GzTheme.productWithoutWarrantyInCart(
          cartItems, productId, productKey, warrantyId
        );

        // 5. Same Product without Warranty already exists in cart
        if (productWithoutWarranty) {

          // 5.1 Update the Product quantity AND remove warranty
          const quantity = productWithoutWarranty.quantity + product.quantity;
          const updates = {
            [warranty.key]: 0,                      // remove warranty
            [product.key]: 0,                       // remove main product
            [productWithoutWarranty.key]: quantity, // update product qty
          };

          return window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, { updates })
            .then((data) => data)
            .catch((error) => {
              const message = `Failed to update cart quantities: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  info: "Error while removing warranty and syncing product quantities.",
                  source: "removeWarranty() flow",
                  location: window.location.href,
                  payload: updates,
                  cartItems: cartItems,
                },
                "error",
                null,
                NS
              );
            });
    
        // 6. Same product without warranty NOT found in cart
        } else {

          // 6.1 Remove product and warranty
          const updates = {
            [warranty.key]: 0,
            [product.key]: 0,
          };

          // Remove unwanted warranty properties
          const cleanedProperties = Object.fromEntries(
            Object.entries(product.properties || {}).filter(
              ([k]) => !["_warranty_uuid", "_warranty.variant_id"].includes(k)
            )
          );

          // 6.2 Add Product back with updated properties if any
          const add = {
            items: [
              {
                id: product.id,
                quantity: product.quantity,
                ...(Object.keys(cleanedProperties).length && { properties: cleanedProperties })
              }
            ]
          };
        
          return window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, { updates })
            .then(() => window.GzTheme.addToCart(add))
            .then((data) => data)
            .catch((error) => {
              const message = `Failed removing warranty and adding product back: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  source: "removeWarranty() flow",
                  updatesPayload: updates,
                  changePayload: change,
                  cartItems: cartItems,
                  location: window.location.href
                },
                "error",
                null,
                NS
              );
            });
        }
      } catch (err) {
        const message = `removeWarranty error: ${err?.message || "Unexpected error"}`;
        window.GzTheme.sendLogsToDatadog(
          message,
          {
            source: "removeWarranty() flow",
            location: window.location.href,
            productId,
            productKey,
            warrantyId,
          },
          "error",
          null,
          NS
        );
      }
    },

    // Add Product and Warranty
    addProductAndWarranty: async function(productId, warrantyId, properties) {
      const uuid = window.GzTheme.generateUUID();
      const NS = window.GzTheme?.namespace || "GZ-WARRANTY";
    
      try {
        // 1. Sync latest cart data
        await window.GzTheme.fetchCart();
        const cartItems = window.GzTheme?.CART_DATA?.items || [];
    
        // 2. Find the product with same warranty
        const product = cartItems.find(item => 
          item.id === productId &&
          item?.properties["_warranty.variant_id"] === warrantyId
        ) || null;

        // 3. Find the warranty from cart
        const warranty = cartItems.find(item => 
          item?.id === warrantyId && 
          item?.properties["_warranty_uuid"] === product?.properties["_warranty_uuid"] &&
          item?.properties["_warranty.associated_variant_id"] === productId
        ) || null;

        // 4. Product already has same warranty in cart
        if (product && warranty) {

          // 4.1 Update the Product and Warranty quantity
          const quantity = product.quantity + 1;
          const updates = {
            [product.key]: quantity,
            [warranty.key]: quantity,
          };

          return window.GzTheme.updateCart(window.GzTheme.CART_UPDATE_ENDPOINT, { updates })
            .then((data) => data)
            .catch((error) => {
              const message = `Failed to add product and warranty from PDP: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  info: "Error while adding warranty and syncing product quantities.",
                  source: "addProductAndWarranty() flow",
                  location: window.location.href,
                  payload: updates,
                  cartItems: cartItems,
                },
                "error",
                null,
                NS
              );
            });
    
        // 5. Product and Warranty is not already in cart
        } else {

          // 5.1 Add Product and Warranty to cart
          const add = {
            items: [
              {
                id: productId,
                quantity: 1,
                properties: {
                  ...properties,
                  "_warranty_uuid": uuid,
                  "_warranty.variant_id": warrantyId
                }
              },
              {
                id: warrantyId,
                quantity: 1,
                properties: {
                  "_warranty_uuid": uuid,
                  "_warranty.associated_variant_id": productId
                }
              }
            ]
          };
        
          return window.GzTheme.addToCart(add)
            .then((data) => data)
            .catch((error) => {
              const message = `Failed adding product and warranty from PDP: ${error?.message}`;
              window.GzTheme.sendLogsToDatadog(
                message,
                {
                  source: "addProductAndWarranty() flow",
                  addPayload: add,
                  cartItems: cartItems,
                  location: window.location.href
                },
                "error",
                null,
                NS
              );
            });
        }
      } catch (err) {
        const message = `addProductAndWarranty error: ${err?.message || "Unexpected error"}`;
        window.GzTheme.sendLogsToDatadog(
          message,
          {
            source: "addProductAndWarranty() flow",
            location: window.location.href,
            productId,
            warrantyId,
            properties
          },
          "error",
          null,
          NS
        );
      }
    },

    // Section Rendering API - Cart Components
    getCartSectionsToRender: function() {
      return [
        {
          selector: '#site-main-header',
          element: '#cart-icon-bubble'
        },
        {
          selector: '#main-cart-items'
        },
        {
          selector: '#main-cart-footer'
        }
      ];
    },

    getSectionIds: function() {
      const sections = this.getCartSectionsToRender();
      
      return sections
        .map(({ selector }) => {
          const element = document.querySelector(selector);
          return element?.dataset.id || null;
        })
        .filter(Boolean);
    },

    getSectionInnerHTML: function(html, selector) {
      const div = document.createElement('div');
      div.innerHTML = html;
      const element = div.querySelector(selector);
      return element ? element.innerHTML : html;
    },

   renderCartSections: function(data) {
      const sections = this.getCartSectionsToRender();
      
      sections.forEach(({ selector, element }) => {
        const sectionElement = document.querySelector(selector);
        if (!sectionElement) {
          console.warn(`[GzTheme] Element not found for selector: ${selector}`);
          return;
        }
        
        const sectionId = sectionElement.dataset.id;
        if (!sectionId) {
          console.warn(`[GzTheme] No data-id attribute found for: ${selector}`);
          return;
        }
        
        const sectionHTML = data.sections?.[sectionId];
        if (!sectionHTML) {
          console.warn(`[GzTheme] No section HTML returned for: ${sectionId}`);
          return;
        }
        
        // If element property exists, update that specific element
        // Otherwise, update the selector element (default behavior)
        const targetSelector = element || selector;
        const targetElement = element ? document.querySelector(element) : sectionElement;
        if (!targetElement) {
          console.warn(`[GzTheme] Target element not found: ${targetSelector}`);
          return;
        }
        
        const innerHTML = this.getSectionInnerHTML(sectionHTML, targetSelector);
        targetElement.innerHTML = innerHTML;
      });
    },

    toggleSkeletonLoaders: function (loading, selectors = []) {
      if (!Array.isArray(selectors)) {
        return;
      }
    
      selectors.forEach(selector => {
        const parent = document.querySelector(selector);
        if (!parent) return;
    
        const skeletons = parent.querySelectorAll('.gz-skeleton-loader');
        skeletons.forEach(skeleton => {
          skeleton.style.display = loading ? 'flex' : 'none';
        });
      });
    },

    // Generate UUID
    generateUUID: function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    // Delay an Async function
    delay: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  });
  
  if (!window.customElements.get('gz-warranty')) {
    class GzWarranty extends HTMLElement {
      constructor() {
        super();
        this.form = null;
        this.radioButtons = [];
        this.itemId = this.closest('.cart-item')?.id || null;
      }
  
      connectedCallback() {
        this.init();
      }

      init() {
        this.addBtns = this.querySelectorAll('button[data-gz-warranty-add]');
        this.removeBtns = this.querySelectorAll('button[data-gz-warranty-remove]');

        this.form = this.querySelector('[gz-warranty-form]');
        if(this.form) {
          this.radioButtons = this.form.querySelectorAll('input[type="radio"][name="warranty"]');
        }

        this.attachEventListeners();
      }

      attachEventListeners() {
        const self = this;

        this.addBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => this.handleAddingWarranty(e));
        });
      
        this.removeBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => this.handleRemovingWarranty(e));
        });
        
        this.radioButtons.forEach(function(radio) {
          radio.addEventListener('change', function(e) {
            const selectedValue = self.parseValue(e.target.value);
      
            if (window.GzTheme) {
              window.GzTheme.GZ_WARRANTY = selectedValue;
            }
          });
        });
      }

      parseValue(value) {
        if (!value || value === '' || value === 'none') {
          return null;
        }
        
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? null : parsed;
      }

      getSelectedValue() {
        const selected = this.form.querySelector('input[type="radio"][name="warranty"]:checked');
        return selected ? this.parseValue(selected.value) : null;
      }

      async handleAddingWarranty(event) {
        event.preventDefault();
        const button = event.currentTarget;
      
        const warrantyId = parseInt(button.getAttribute('data-gz-warranty-add'));
        const productId = parseInt(button.getAttribute('data-gz-associated-item-id'));
        const productKey = button.getAttribute('data-gz-associated-item-key');
      
        this.setLoading(true);
      
        try {
          const data = await window.GzTheme.addWarranty(productId, productKey, warrantyId);
          if (data) {
            window.GzTheme.renderCartSections(data);
          } else {
            console.warn("addWarranty failed, check internal logs.");
          }
        } finally {
          this.setLoading(false);
        }
      }

      async handleRemovingWarranty(event) {
        event.preventDefault();
        const button = event.currentTarget;
      
        const warrantyId = parseInt(button.getAttribute('data-gz-warranty-remove'));
        const productId = parseInt(button.getAttribute('data-gz-associated-item-id'));
        const productKey = button.getAttribute('data-gz-associated-item-key');
      
        this.setLoading(true);
      
        try {
          const data = await window.GzTheme.removeWarranty(productId, productKey, warrantyId);
          if (data) {
            window.GzTheme.renderCartSections(data);
          } else {
            console.warn("removeWarranty failed, check internal logs.");
          }
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        window.GzTheme.toggleSkeletonLoaders(isLoading, [
          `#${this.itemId}`,
          '#main-cart-footer'
        ]);
      }
    }
    
    window.customElements.define('gz-warranty', GzWarranty);
  }

  if (!window.customElements.get('gz-cart-item')) {
    class GzCartItem extends HTMLElement {
      constructor() {
        super();
        this.cartItems = document.querySelector(".gz-cart-items");
        this.itemId = this.closest('.cart-item')?.id || null;
      }
    
      connectedCallback() {
        this.input = this.querySelector('input[name="quantity"]');
        this.minusBtn = this.querySelector('button[name="minus"]');
        this.plusBtn = this.querySelector('button[name="plus"]');
        this.removeBtn = this.querySelector('button[name="remove"]');
    
        if (!this.input) return;
    
        this.lineIndex = parseInt(this.input.dataset.index);
        this.warrantyKey = this.input.dataset.warrantyKey;
        this.itemKey = this.input.dataset.itemKey;
    
        this.minusBtn?.addEventListener('click', this.handleDecrease.bind(this));
        this.plusBtn?.addEventListener('click', this.handleIncrease.bind(this));
        this.removeBtn?.addEventListener('click', this.handleRemove.bind(this));
        this.input.addEventListener('change', this.handleInputChange.bind(this));
      }

      handleDecrease(e) {
        e.preventDefault();
        const currentValue = parseInt(this.input.value);
        const min = parseInt(this.input.min) || 1;
        const step = parseInt(this.input.step) || 1;
    
        if (currentValue > min) {
          this.input.value = currentValue - step;
          this.updateQuantity(currentValue - step);
        }
      }
    
      handleIncrease(e) {
        e.preventDefault();
        const currentValue = parseInt(this.input.value);
        const max = this.input.max ? parseInt(this.input.max) : Infinity;
        const step = parseInt(this.input.step) || 1;
    
        if (currentValue < max) {
          this.input.value = currentValue + step;
          this.updateQuantity(currentValue + step);
        }
      }

      handleRemove(e) {
        e.preventDefault();
        this.updateQuantity(0);
      }
    
      handleInputChange(e) {
        const value = parseInt(e.target.value);
        const min = parseInt(this.input.min) || 1;
        const max = this.input.max ? parseInt(this.input.max) : Infinity;
    
        if (value < min) {
          this.input.value = min;
          this.updateQuantity(min);
        } else if (value > max) {
          this.input.value = max;
          this.updateQuantity(max);
        } else {
          this.updateQuantity(value);
        }
      }
    
      updateQuantity(quantity) {
        this.performUpdate(quantity);
      }
    
      async performUpdate(quantity) {
        let updates = {};
        const NS = window.GzTheme?.namespace || "GZ-WARRANTY";

        // Set loading state
        this.setLoading(true);

        try {
      
          if (this.itemKey) {
            updates[String(this.itemKey)] = quantity;
          }
      
          if (this.warrantyKey) {
            updates[String(this.warrantyKey)] = quantity;
          }

          // Update items quantity
          const data = await window.GzTheme.updateCart(
            window.GzTheme.CART_UPDATE_ENDPOINT, 
            { updates }
          );

          // Check if cart is empty
          if (data.item_count === 0) {
            this.handleEmptyCart();
          }
      
          // Refresh sections content
          window.GzTheme.renderCartSections(data);
      
        } catch (error) {
          const message = error.message;

          window.GzTheme.sendLogsToDatadog(
            message,
            {
              info: 'Item update failed on cart page.',
              source: 'GzCartItem Component',
              location: window.location.href,
              payload: updates
            },
            'error',
            null,
            NS
          );
          return;
        } finally {
          this.setLoading(false);
        }
      }
    
      setLoading(isLoading) {
        window.GzTheme.toggleSkeletonLoaders(isLoading, [
          `#${this.itemId}`,
          '#main-cart-footer'
        ]);
      }

      handleEmptyCart() {
        this.cartItems && this.cartItems.classList.add("is-empty")
      }
    }
    
    customElements.define('gz-cart-item', GzCartItem);
  }
});